import Clock from "~/icons/Clock"

export interface Props {
  hoursText: string
}

const HoursDisplay = ({ hoursText }: Props) => {
  return (
    <p className="text-sm text-white">
      <Clock className="w-4 h-4 inline-block mr-1" />
      Today's Hours:{" "}
      <span className="font-semibold uppercase">{hoursText}</span>
    </p>
  )
}

HoursDisplay.displayName = "HoursDisplay"

export { HoursDisplay }
export default HoursDisplay
